// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.interactionhistorydialog_featuredInteractionHistoryDialogItem__9VjVq {
    flex: 1 1;
    margin: 0px 10px;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
    vertical-align: top;
}

.interactionhistorydialog_featured__hEiQ6 {
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.interactionhistorydialog_featuredItem__ktAWB {
    flex: 1 1;
    margin: 0px 20px;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);
}

.interactionhistorydialog_featuredTitleHeader__qXGmT {
    font-size: 17px;
    font-weight: bold;
}

.interactionhistorydialog_dialogInputs__th4iq {
    width: 100%;
}

.interactionhistorydialog_dialogReadOnlyInputs__dCq4g {
    width: 100%;
    z-index: 1000;
    pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/components/InteractionHistoryDialog/interactionhistorydialog.module.css"],"names":[],"mappings":"AAAA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IAEnB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oBAAoB;AACxB","sourcesContent":[".featuredInteractionHistoryDialogItem {\r\n    flex: 1;\r\n    margin: 0px 10px;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    vertical-align: top;\r\n}\r\n\r\n.featured {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.featuredItem {\r\n    flex: 1;\r\n    margin: 0px 20px;\r\n    padding: 30px;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.75);\r\n}\r\n\r\n.featuredTitleHeader {\r\n    font-size: 17px;\r\n    font-weight: bold;\r\n}\r\n\r\n.dialogInputs {\r\n    width: 100%;\r\n}\r\n\r\n.dialogReadOnlyInputs {\r\n    width: 100%;\r\n    z-index: 1000;\r\n    pointer-events: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"featuredInteractionHistoryDialogItem": `interactionhistorydialog_featuredInteractionHistoryDialogItem__9VjVq`,
	"featured": `interactionhistorydialog_featured__hEiQ6`,
	"featuredItem": `interactionhistorydialog_featuredItem__ktAWB`,
	"featuredTitleHeader": `interactionhistorydialog_featuredTitleHeader__qXGmT`,
	"dialogInputs": `interactionhistorydialog_dialogInputs__th4iq`,
	"dialogReadOnlyInputs": `interactionhistorydialog_dialogReadOnlyInputs__dCq4g`
};
export default ___CSS_LOADER_EXPORT___;
